import { IColumn, ILayerColumnList, ILayerColumnValueOverrides } from "src/app/models";

class Environment {
    static get init(): IEnvironment {
        const env = (<any>window).environment || 'local';
        var settings = this.common;
        var environmentSettings = this.environments[env];
        for (const key of Object.keys(environmentSettings)) {
            settings[key] = environmentSettings[key];
        }
        return settings;
    }

    static environments: { [key: string]: IEnvironment } = {
        local: {
            appPath: '//localhost/tire',
            exportWebMapTaskUrl: 'https://pddvgisweb.penndot.pa.gov/mapcore/api/gis/print',
            pdauthURL: 'https://localhost/PDAUTH',
            mapcoreApi: 'https://pddvgisweb.penndot.pa.gov/mapcore/api/',
            simpleMapId: 22457,
            completeMapId: 14837
        },
        dev: {
            appPath: '//pddvgisweb.penndot.pa.gov/tire',
            exportWebMapTaskUrl: 'https://pddvgisweb.penndot.pa.gov/gis/rest/services/Utilities/PrintingTools/GPServer/Export%20Web%20Map%20Task',
            pdauthURL: 'https://pddvgisweb.penndot.pa.gov:8443/PDAUTH',
            mapcoreApi: 'https://pddvgisweb.penndot.pa.gov/mapcore/api/',
            simpleMapId: 22457,
            completeMapId: 14837
        },
        test: {
            appPath: 'https://gistest.penndot.pa.gov/tire',
            exportWebMapTaskUrl: 'https://gistest.penndot.pa.gov/gisgp/rest/services/Utilities/PrintingTools/GPServer/Export%20Web%20Map%20Task',
            pdauthURL: 'https://gistest.penndot.pa.gov/PDAUTH',
            mapcoreApi: 'https://gistest.penndot.pa.gov/mapcore/api/',
            simpleMapId: 22070,
            completeMapId: 14837
        },
        prod: {
            appPath: '//gis.penndot.pa.gov/tire',
            exportWebMapTaskUrl: 'https://gis.penndot.pa.gov/gisgp/rest/services/Utilities/PrintingTools/GPServer/Export%20Web%20Map%20Task',
            pdauthURL: 'https://gis.penndot.pa.gov/PDAUTH',
            mapcoreApi: 'https://gis.penndot.pa.gov/mapcore/api/',
            simpleMapId: 28278,
            completeMapId: 14837
        }
    };

    static get common(): IEnvironment {
        return {
            appId: 15,
            pdauthAppName: 'TIRE',
            appPath: 'TIRE',
            version: '2.0.7',
            minScale: 1155582,
            tmsStationLayerIds: [2610, 2611],
            cycleBaseYear: 2009,
            currentCountAssignmentsLayerRange: [2631, 2661],
            aoiSettings: {
                assetIdConfig: [
                    {
                        columnName: 'TMS_SITE_NO',
                        displayName: 'TMS Site Numbers',
                        idType: '$stringId',
                        propName: 'tmsSiteNumbers',
                        fieldName: 'tmsSiteNumber',
                        layerId: 2611
                    },
                    {
                        columnName: 'PERMANENT_SITE_ID',
                        displayName: 'TMS Permanent Site Ids',
                        idType: '$stringId',
                        propName: 'tmsPermanentSiteNumbers',
                        fieldName: 'tmsPermanentSiteNumber',
                        layerId: 2611
                    },
                    {
                        columnName: 'BRKEY',
                        displayName: 'Bridge Keys',
                        idType: '$stringIds',
                        propName: 'bridges',
                        fieldName: 'brKey',
                        layerId: 1592
                    },
                    {
                        columnName: 'PROJECT_ID',
                        displayName: 'MPMS Projects',
                        idType: '$stringIds',
                        propName: 'mpmsprojects',
                        fieldName: 'id',
                        layerId: 2751
                    },
                    {
                        columnName: 'HPMS_SAMP_SECT_NO',
                        displayName: 'HPMS Sample',
                        idType: '$stringIds',
                        propName: 'hpmsSamples',
                        fieldName: 'hpmsSample',
                        layerId: 2000
                    }
                ],
                assetIdProperties: 'hpmsSamples,bridges,mpmsprojects,tmsSiteNumbers,tmsPermanentSiteNumbers',
                mapPickerConfig: {
                    category: 'TIRE',
                    map: 'Simple (TMS Sites Only)'
                }
            },
            dataTableColumnNames: ['permit_number', 'sign_appl_id', 'district_number', 'county_code', 'route_number', 'sign_classification_code', 'sign_type_code', 'status_code', 'sign_owner_name'],
            disclaimerCookieName: 'tire_disclaimer_accepted',
            disclaimerDoNotAcceptUrl: 'https://www.penndot.pa.gov/',
            disclaimerExpirationDays: 30,
            dotNetCore: false,
            extentConfigs: [
                {
                    toolTip: "Statewide",
                    icon: "m28.531 12.656-.187-.531-1.156-.344-.344-.562-.187-1.437-.719-.312-.094-.344-.375-.312h-20.219v-1.625l-1.656.844 .219-.312-.656.5-1.375.594-.406 13.906 20.719.094h1.719l.313-.531.5-.25.781 .156 1.375-.562.094-.437 1.75-1.312-1.187-1.437h-.25l-.25-.875-.531-.062-.031-.75v-.375l.406-.25.188-.469-.375-.75.844-.844.719-1.25z",
                    color: "white",
                    extent: {
                        center: [-77.6362661695295, 40.92039887644528],
                        zoom: 8
                    },
                    extentType: "static",
                    label: "Statewide Extent"
                },
                {
                    toolTip: "Current Area of Interest",
                    icon: "icon-ui-locate",
                    color: "white",
                    extentType: "async-func",
                    label: "AOI"
                }
            ],
            columnAliasOverrides: [
                { name: "AADT", alias: "Current AADT" },
                { name: "AADT_CUR", alias: "Avg. Daily Traffic" },
                { name: "ADTT_CUR", alias: "Avg. Daily Truck Traffic" },
                { name: "BGN_DESC", alias: "Begin Description" },
                { name: "CRACK_PCT", alias: "Cracking Percent" },
                { name: "CTR_PEAK_LANES", alias: "Counter Peak Lanes" },
                { name: "CTY_CODE", alias: "County" },
                { name: "CUR_AADT", alias: "Avg. Daily Traffic" },
                { name: "CURRENT_AADT", alias: "Avg. Daily Traffic" },
                { name: "CUR_ADTT", alias: "Avg. Daily Truck Traffic" },
                { name: "DISTRICT_NO", alias: "District" },
                { name: "DIR_IND", alias: "Direction" },
                { name: "DLY_VMT", alias: "Daily Vehicle Miles Traveled" },
                { name: "DLY_TRK_VMT", alias: "Daily Truck Vehicle Miles Traveled" },
                { name: "DURATION", alias: "Count Duration" },
                { name: "DUR_CLS_CNT", alias: "Count Duration" },
                { name: "END_DESC", alias: "End Description" },
                { name: "FED_SHLD_TYPE", alias: "Shoulder Type" },
                { name: "FIPS_AREA_CODE", alias: "FIPS Area Code" },
                { name: "FUNC_CLS", alias: "PennDOT Functional Class" },
                { name: "FHWA_FUNC_CLS", alias: "FHWA Functional Class" },
                { name: "FREQ_CYCLE", alias: "Frequency Cycle" },
                { name: "FN_LATITUDE", alias: "Latitude" },
                { name: "FN_LONGITUDE", alias: "Longitude" },
                { name: "GREEN_TIME_PCT", alias: "Percent Green Time" },
                { name: "HPMS_SAMP_SECT_NO", alias: "Sample ID" },
                { name: "HPMS_SAMPLE_COUNT", alias: "HPMS Sample" },
                { name: "HPMS_SAMP_CNT", alias: "HPMS Sample" },
                { name: "INTERST_NETWRK_IND", alias: "Interstate Network Indicator" },
                { name: "JURIS", alias: "Jurisdiction" },
                { name: "LAST_OVERLAY_THICK", alias: "Last Overlay" },
                { name: "LANE_CNT", alias: "Lane Count" },
                { name: "MAINT_FUNC_CLS", alias: "Maint. Functional Class" },
                { name: "NHS_IND", alias: "NHS Indicator" },
                { name: "OFFSET_BGN", alias: "Offset Begin" },
                { name: "OFFSET_END", alias: "Offset End" },
                { name: "PA_BYWAY_IND", alias: "PA Byway Indicator" },
                { name: "PCT_PASS_SIGHT", alias: "Percent Pass Sight" },
                { name: "PEAK_THRU_LANES", alias: "Peak Lanes" },
                { name: "PLOTCOLOR", alias: "Plot Color" },
                { name: "PREVAIL_SGNL_TYPE", alias: "Signal Type" },
                { name: "PRIMARY_ALTERNATE_ROUTE_NO", alias: "Primary Alternate Route" },
                { name: "RESP_AGENCY", alias: "Responsible Agency" },
                { name: "ROUTE_DIR", alias: "Direction" },
                { name: "SCENIC_BYWAY_NETWORK", alias: "PA Byway Indicator" },
                { name: "SECONDARY_ALTERNATE_ROUTE_NO", alias: "Secondary Alternate Route" },
                { name: "SEG_BGN", alias: "Segment Begin" },
                { name: "SEG_NO", alias: "Segment" },
                { name: "SEG_END", alias: "Segment End" },
                { name: "SEG_LNGTH_FEET", alias: "Length" },
                { name: "SEG_OFFSET", alias: "Offset" },
                { name: "SHLD_TOTAL_WIDTH_L", alias: "Left Shoulder Width" },
                { name: "SHLD_TOTAL_WIDTH_R", alias: "Right Shoulder Width" },
                { name: "SIGNAL_COUNT", alias: "Number Signals" },
                { name: "ST_RT_NO", alias: "Route" },
                { name: "STOP_SIGN_COUNT", alias: "Stop Signs" },
                { name: "TMS_SITE_NO", alias: "Site Number" },
                { name: "TRAF_RT_NO", alias: "Traffic Route" },
                { name: "TRAF_RT_NO2", alias: "Primary Alternate Route" },
                { name: "TRAF_RT_NO3", alias: "Secondary Alternate Route" },
                { name: "TRAFFIC_ROUTE_NUMBER", alias: "Traffic Route" },
                { name: "TRN_LANE_LEFT", alias: "Left Turn Lane" },
                { name: "TRN_LANE_RIGHT", alias: "Right Turn Lane" },
                { name: "TRK_PCT", alias: "Truck Percent" },
                { name: "TRAFF_PATT_GRP", alias: "Traffic Pattern Group" },
                { name: "TYPE_OF_CNT", alias: "Type of Count" },
                { name: "URBAN_RURAL", alias: "Urban / Rural Indicator" },
                { name: "VOL_CNT_DATE", alias: "Count Date" },
                { name: "VOL_CNT_KEY", alias: "Traffic Count Key" },
                { name: "WIDEN_OBST", alias: "Widening Obstacle" },
                { name: "WIDEN_POTENTIAL", alias: "Widening Potential" }
            ],
            layerColumnValueOverrides: [
                {
                    layerId: 1100,
                    columnValueDescriptions: [
                        {
                            columnName: "FHWA_FUNC_CLS",
                            valuesAndDescriptions: ['1|Interstate', '2|Other Freeway/Expressway', '3|Other Principal Arterial', '4|Minor Arterial', '5|Collector', '6|Minor Collector', '7|Local']
                        }
                    ]
                }
            ],
            layerColumnLists: [
                { layerId: 1100, columnList: ['CTY_CODE', 'DISTRICT_NO', 'FHWA_FUNC_CLS', 'FIPS_AREA_CODE', 'FUNC_CLS', 'JURIS', 'MAINT_FUNC_CLS', 'OFFSET_BGN', 'OFFSET_END', 'SEG_BGN', 'SEG_END', 'ST_RT_NO'] }, 
                { layerId: 2000, columnList: ['BASE_THICKNESS', 'BASE_TYPE', 'CRACK_PCT', 'CTR_PEAK_LANES', 'CTY_CODE', 'DISTRICT_NO', 'FAULTING', 'FED_SHLD_TYPE', 'GREEN_TIME_PCT', 'HPMS_SAMP_SECT_NO', 'JURIS', 'LANE_WIDTH', 'LAST_OVERLAY_THICK', 'MEDIAN_TYPE', 'MEDIAN_WIDTH', 'OFFSET_BGN', 'OFFSET_END', 'PCT_PASS_SIGHT', 'PEAK_PARKING', 'PEAK_THRU_LANES', 'PREVAIL_SGNL_TYPE', 'RESP_AGENCY', 'RUTTING', 'SEG_BGN', 'SEG_END', 'SEG_LNGTH_FEET', 'SHLD_TOTAL_WIDTH_L', 'SHLD_TOTAL_WIDTH_R', 'SIGNAL_COUNT', 'ST_RT_NO', 'STOP_SIGN_COUNT', 'TERRAIN_TYPE', 'THICKNESS_FLEXIBLE', 'THICKNESS_RIGID', 'TRN_LANE_LEFT', 'TRN_LANE_RIGHT', 'WIDEN_OBST', 'WIDEN_POTENTIAL'] },
                { layerId: 1253, columnList: ['ST_RT_NO', 'CTY_CODE', 'DISTRICT_NO', 'JURIS', 'SEG_NO', 'LANE_CNT', 'CUR_AADT', 'STREET_NAME', 'TRAF_RT_NO', 'BGN_DESC', 'END_DESC', 'URBAN_RURAL', 'NHS_IND', 'INTERST_NETWRK_IND', 'SIDE_IND', 'PA_BYWAY_IND', 'TRAF_RT_NO2', 'TRAF_RT_NO3', 'ROUTE_DIR', 'HPMS_SAMP_CNT']},
                { layerId: 2610, columnList: ['COUNT_SCHEDULE', 'CTY_CODE', 'CYCLE_YEAR', 'DATA_TYPE', 'DESCRIPTION', 'DURATION', 'FN_LATITUDE', 'FN_LONGITUDE', 'FREQ_CYCLE', 'FUNCTION_TYPE', 'SEG_NO', 'SEG_OFFSET', 'ST_RT_NO', 'TMS_SITE_NO'] },
                { layerId: 2611, columnList: ['COUNT_SCHEDULE', 'CTY_CODE', 'CYCLE_YEAR', 'DATA_TYPE', 'DESCRIPTION', 'DURATION', 'FN_LATITUDE', 'FN_LONGITUDE', 'FREQ_CYCLE', 'FUNCTION_TYPE', 'SEG_NO', 'SEG_OFFSET', 'ST_RT_NO', 'STREET_NAME', 'TMS_SITE_NO', 'PERMANENT_SITE_ID'] },
                { layerId: 2625, columnList: ['ADTT_CUR', 'CTY_CODE', 'CUR_AADT', 'DIR_IND', 'DISTRICT_NO', 'DLY_TRK_VMT', 'DLY_VMT', 'DUR_CLS_CNT', 'D_FACTOR', 'JURIS', 'K_FACTOR', 'OFFSET_BGN', 'OFFSET_END', 'SEG_BGN', 'SEG_END', 'SIDE_IND', 'ST_RT_NO', 'TRAFF_PATT_GRP', 'TRK_PCT', 'TYPE_OF_CNT', 'T_FACTOR', 'VOL_CNT_DATE', 'VOL_CNT_KEY'] },
                { layerId: 2627, columnList: ['PLOTCOLOR', 'CTY_CODE', 'ST_RT_NO', 'JURIS', 'SEG_BGN', 'OFFSET_BGN', 'SEG_END', 'OFFSET_END', 'SEG_LNGTH_FEET', 'SIDE_IND'] }
            ]
        };
    }
}

interface IEnvironment {
    aoiSettings?: any;
    appId?: number;
    appPath?: string;
    assetIdProperties?: string;
    columnAliasOverrides?: IColumn[];
    cycleBaseYear?: number;
    currentCountAssignmentsLayerRange?: number[];
    tmsStationLayerIds?: number[];
    dataTableColumnNames?: string[];
    disclaimerCookieName?: string;
    disclaimerDoNotAcceptUrl?: string;
    disclaimerExpirationDays?: number;
    dotNetCore?: boolean;
    extentConfigs?: any[];
    exportWebMapTaskUrl?: string;
    layerColumnLists?: ILayerColumnList[];
    layerColumnValueOverrides?: ILayerColumnValueOverrides[];
    pdauthURL?: string;
    pdauthAppName?: string;
    pdauthToken?: string;
    mapcoreApi?: string;
    minScale?: number;
    simpleMapId?: number;
    completeMapId?: number;
    version?: string;
}

export const environment = Environment.init;
